export default function DeleteIcon({ color = "#DC3545" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
    >
      <path
        d="M13.1872 3.9375L0.812195 3.9375M12.0625 3.9375V14.625C12.0625 14.7742 12.0032 14.9173 11.8977 15.0227C11.7922 15.1282 11.6492 15.1875 11.5 15.1875H2.49997C2.35079 15.1875 2.20771 15.1282 2.10222 15.0227C1.99673 14.9173 1.93747 14.7742 1.93747 14.625V3.9375M4.18747 1.6875H9.81247"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
